//Effects
import { all, put, select, takeLatest } from 'redux-saga/effects';

import {
  ADD_TASK_LOCATION,
  ADD_TASK_LOCATION_FAILURE,
  ADD_TASK_LOCATION_SUCCESS,
  CREATE_LINK_TASK,
  CREATE_LINK_TASK_FAILURE,
  CREATE_LINK_TASK_SUCCESS,
  CREATE_MASTER_TASK,
  CREATE_MASTER_TASK_FAILURE,
  CREATE_MASTER_TASK_SUCCESS,
  CREATE_MAX_TASK_DURATION,
  CREATE_MAX_TASK_DURATION_FAILURE,
  CREATE_MAX_TASK_DURATION_SUCCESS,
  GET_MAX_TASK_DURATION,
  GET_MAX_TASK_DURATION_FAILURE,
  GET_MAX_TASK_DURATION_SUCCESS,
  ARCHIVE_TASK_LOCATION,
  ARCHIVE_TASK_LOCATION_FAILURE,
  ARCHIVE_TASK_LOCATION_SUCCESS,
  CREATE_TASK,
  CREATE_TASK_FAILURE,
  CREATE_TASK_SUCCESS,
  DELETE_TASK,
  DELETE_TASK_FAILURE,
  DELETE_TASK_SUCCESS,
  DUPLICATE_TASK,
  DUPLICATE_TASK_FAILURE,
  DUPLICATE_TASK_SUCCESS,
  EDIT_TASK,
  EDIT_TASK_FAILURE,
  EDIT_TASK_SUCCESS,
  GET_MASTER_TASK,
  GET_MASTER_TASK_FAILURE,
  GET_MASTER_TASK_SUCCESS,
  GET_NEW_TASK,
  GET_NEW_TASK_FAILURE,
  GET_NEW_TASK_SUCCESS,
  GET_LOCATION_TYPE_LIST,
  GET_LOCATION_TYPE_LIST_FAILURE,
  GET_LOCATION_TYPE_LIST_SUCCESS,
  GET_TASKS_LIST,
  GET_TASKS_LIST_FAILURE,
  GET_TASKS_LIST_SUCCESS,
  GET_TASK_DETAILS,
  GET_TASK_DETAILS_FAILURE,
  GET_TASK_DETAILS_SUCCESS,
  GET_TASK_LOCATIONS,
  GET_TASK_LOCATIONS_FAILURE,
  GET_TASK_LOCATIONS_SUCCESS,
  GET_TASK_TYPE,
  GET_TASK_TYPE_FAILURE,
  GET_TASK_TYPE_SUCCESS,
  UPDATE_TASK_LOCATION,
  UPDATE_TASK_LOCATION_FAILURE,
  UPDATE_TASK_LOCATION_SUCCESS,
  UPDATE_TASK_STATUS,
  UPDATE_TASK_STATUS_FAILURE,
  UPDATE_TASK_STATUS_SUCCESS,
  UPDATE_MASTER_TASK,
  UPDATE_MASTER_TASK_FAILURE,
  UPDATE_MASTER_TASK_SUCCESS,
  ARCHIVE_MASTER_TASK,
  ARCHIVE_MASTER_TASK_FAILURE,
  ARCHIVE_MASTER_TASK_SUCCESS,
  UNARCHIVE_MASTER_TASK,
  UNARCHIVE_MASTER_TASK_SUCCESS,
  UNARCHIVE_MASTER_TASK_FAILURE,
  EXPORT_TASKS,
  EXPORT_TASKS_SUCCESS,
  EXPORT_TASKS_FAILURE,
} from '../../modules/constants';
//Service
import { defaultApi } from '../../utils/axiosApi';
import details from '../IntegrationsNew/Details';

export function* handleGetTasksList({ payload }) {
  const {
    startDate,
    endDate,
    page,
    task_name,
    office_id,
    assignee_id,
    status,
    approval_status,
  } = payload;
  try {
    const url = `/tasks/?required_start_date=${startDate}&required_end_date=${endDate}${page ? `&page=${page}` : ''
      }${task_name ? `&name=${task_name}` : ''}${office_id ? `&office_id=${office_id}` : ''
      }${assignee_id ? `&assignees=${assignee_id}` : ''}${status ? `&status=${status}` : ''
      }${approval_status ? `&approval_status=${approval_status}` : ''}`;
    const response = yield defaultApi(url, 'GET', payload);
    yield put({
      type: GET_TASKS_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASKS_LIST_FAILURE,
      payload: err,
    });
  }
}

export function* handleCreateTaskList({ payload }) {
  try {
    const { ...details } = payload;
    const url = `/tasks/`;
    const method = 'POST';
    const response = yield defaultApi(url, method, details);
    yield put({
      type: CREATE_TASK_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: CREATE_TASK_FAILURE,
      payload: err,
    });
  }
}

// master Task

export function* handleCreateMasterTaskList({ payload }) {
  try {
    const { ...details } = payload;
    const url = `/albait/master-tasks/`;
    const method = 'POST';
    const response = yield defaultApi(url, method, details);
    yield put({
      type: CREATE_MASTER_TASK_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: CREATE_MASTER_TASK_FAILURE,
      payload: err,
    });
  }
}

// create link task
export function* handleCreateLinkTaskList({ payload }) {
  try {
    const { ...details } = payload;
    const url = `/albait/master-tasks/link-task/`;
    const method = 'POST';
    const response = yield defaultApi(url, method, details);
    yield put({
      type: CREATE_LINK_TASK_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: CREATE_LINK_TASK_FAILURE,
      payload: err,
    });
  }
}

// create max task duration
export function* handleCreateMaxTaskDuration({ payload }) {
  try {
    const { ...details } = payload;
    const url = `/albait/task-duration-config/`;
    const method = 'POST';
    const response = yield defaultApi(url, method, details);
    yield put({
      type: CREATE_MAX_TASK_DURATION_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: CREATE_MAX_TASK_DURATION_FAILURE,
      payload: err,
    });
  }
}

// Add a new saga to fetch max task duration
export function* handleGetMaxTaskDuration() {
  try {
    const url = `/albait/task-duration-config/`;
    const method = 'GET';
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_MAX_TASK_DURATION_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_MAX_TASK_DURATION_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetTaskDetails({ payload }) {
  try {
    const { task_id } = payload;
    const url = `/tasks/${task_id}/`;
    const method = 'GET';
    const response = yield defaultApi(url, method);
    yield put({
      type: GET_TASK_DETAILS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASK_DETAILS_FAILURE,
      payload: err,
    });
  }
}

export function* handleEditTask({ payload }) {
  try {
    const { task_id, ...details } = payload;
    const url = `/tasks/${task_id}/`;
    const response = yield defaultApi(url, 'PUT', details);
    yield put({
      type: EDIT_TASK_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: EDIT_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleDuplicateTask({ payload }) {
  try {
    const { organization_id, ...details } = payload;
    const url = `/tasks/duplicate-task`;
    const method = 'POST';
    const response = yield defaultApi(url, method, details);

    yield put({
      type: DUPLICATE_TASK_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: DUPLICATE_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleDeleteTask({ payload }) {
  try {
    const { task_id } = payload;
    const url = `/tasks/${task_id}/`;
    const method = 'DELETE';
    const response = yield defaultApi(url, method);
    yield put({
      type: DELETE_TASK_SUCCESS,
      payload: { data: response, task_id, notify: 'DELETE' },
    });
  } catch (err) {
    yield put({
      type: DELETE_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetTaskLocations({ payload }) {
  try {
    let url = '/task_locations/?';
    const params = [];
    // add is_active parameter
    //params.push(`is_active=True`);

    if (payload) {
      if (payload.office_id) {
        params.push(`office_id=${payload.office_id}`);
      }

      // Handle is_active parameter - convert boolean to string for URL
      if (payload.is_active !== undefined) {
        params.push(`is_active=${payload.is_active ? 'True' : 'False'}`);
      } else {
        params.push(`is_active=True`);
      }

      // Handle is_catering_location parameter
      if (payload.is_catering_location !== undefined) {
        params.push(`is_catering_location=${payload.is_catering_location ? 'True' : 'False'}`);
      }
    } else {
      params.push(`is_active=True`);
    }
    // Add other parameters as needed

    // Join all parameters with &
    url += params.join('&');

    console.log('API URL:', url); // Debug log

    const response = yield defaultApi(url, 'GET');
    yield put({
      type: GET_TASK_LOCATIONS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    console.error('Error fetching task locations:', err);
    yield put({
      type: GET_TASK_LOCATIONS_FAILURE,
      payload: err,
    });
  }
}

export function* handleAddTaskLocation({ payload }) {
  try {
    const { ...details } = payload;
    const url = `/task_locations/`;
    const method = 'POST';
    const response = yield defaultApi(url, method, details);

    if (response.status === 201) {
      // refetch the task locations
      yield put({
        type: GET_TASK_LOCATIONS,
        payload: { office_id: details.office_id, is_active: true },
      });
    }
    yield put({
      type: ADD_TASK_LOCATION_SUCCESS,
      payload: { data: response, notify: 'POST' },
    });
  } catch (err) {
    yield put({
      type: ADD_TASK_LOCATION_FAILURE,
      payload: err,
    });
  }
}
export function* handleTaskApproval({ payload }) {
  const { task_id, approval_id, details } = payload;
  try {
    const url = `tasks/${task_id}/approval/${approval_id}/`;
    const method = 'PUT';
    const response = yield defaultApi(url, method, details);
    yield put({
      type: UPDATE_TASK_STATUS_SUCCESS,
      payload: { data: response, task_id },
    });
  } catch (err) {
    yield put({
      type: UPDATE_TASK_STATUS_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetTaskType({ }) {
  try {
    const url = `/tasks/task-type/`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_TASK_TYPE_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_TASK_TYPE_FAILURE,
      payload: err,
    });
  }
}

export function* handleGetMasterTask({ payload }) {
  try {
    const { master_task_id, show_archived } = payload;
    const url = `/albait/master-tasks/?task_type=${master_task_id}&is_active=${show_archived ? 'False' : 'True'}`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_MASTER_TASK_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_MASTER_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleUpdateTaskLocation({ payload }) {
  try {
    const { task_location_id, ...details } = payload;
    const url = `/task_locations/${task_location_id}/`;
    const method = 'PATCH';
    const response = yield defaultApi(url, method, details);

    if (response.status === 200) {
      // refetch the task locations
      yield put({
        type: GET_TASK_LOCATIONS,
        payload: { office_id: details.office_id, is_active: true },
      });
    }
    yield put({
      type: UPDATE_TASK_LOCATION_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: UPDATE_TASK_LOCATION_FAILURE,
      payload: {
        data: err.response?.data || { status: err.status || 500 },
        response: err.response
      },
    });
  }
}

export function* handleGetNewTask({ payload }) {
  try {
    const { task_type } = payload;
    const url = `/albait/new-tasks/?is_new=True&task_type=${task_type}`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_NEW_TASK_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_NEW_TASK_FAILURE,
      payload: err,
    });
  }
}


export function* handleGetLocationTypeList({ payload }) {
  try {
    const url = `/task_locations/type/`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_LOCATION_TYPE_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_LOCATION_TYPE_LIST_FAILURE,
      payload: err,
    });
  }
}

// Add this saga function
export function* archiveTaskLocationSaga({ payload }) {
  try {
    const { location_id, is_active } = payload;
    const url = `/task_locations/${location_id}/`;
    const method = is_active ? 'PATCH' : 'DELETE';
    const data = { is_active: is_active ? "True" : "False" };
    const response = yield defaultApi(url, method, data);
    yield put({
      type: ARCHIVE_TASK_LOCATION_SUCCESS,
      payload: { data: response, locationId: location_id },
    });
  } catch (err) {
    yield put({
      type: ARCHIVE_TASK_LOCATION_FAILURE,
      payload: err,
    });
  }
}

// update master task
export function* handleUpdateMasterTask({ payload }) {
  try {
    const { id, ...details } = payload;
    const url = `/albait/master-tasks/${id}/`;
    const method = 'PATCH';
    const response = yield defaultApi(url, method, details);
    yield put({
      type: UPDATE_MASTER_TASK_SUCCESS,
      payload: { data: response, notify: 'PATCH' },
    });
  } catch (err) {
    yield put({
      type: UPDATE_MASTER_TASK_FAILURE,
      payload: err,
    });
  }
}

// archive master task
export function* handleArchiveMasterTask({ payload }) {
  try {
    const { id } = payload;
    const url = `/albait/master-tasks/${id}/`;
    const method = 'PATCH';
    const details = { is_active: false };
    const response = yield defaultApi(url, method, details);
    yield put({
      type: ARCHIVE_MASTER_TASK_SUCCESS,
      payload: { data: response, notify: 'PATCH' },
    });
  } catch (err) {
    yield put({
      type: ARCHIVE_MASTER_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleUnarchiveMasterTask({ payload }) {
  try {
    const { id } = payload;
    const url = `/albait/master-tasks/${id}/`;
    const method = 'PATCH';
    const details = { is_active: true };
    const response = yield defaultApi(url, method, details);
    yield put({
      type: UNARCHIVE_MASTER_TASK_SUCCESS,
      payload: { data: response, notify: 'PATCH' },
    });
  } catch (err) {
    yield put({
      type: UNARCHIVE_MASTER_TASK_FAILURE,
      payload: err,
    });
  }
}

export function* handleExportTasks({ payload }) {
  const {
    startDate,
    endDate,
    task_name,
    office_id,
    assignee_id,
    status,
    approval_status,
  } = payload;
  try {
    const url = `/tasks/export-tasks/?required_start_date=${startDate}&required_end_date=${endDate}${task_name ? `&name=${task_name}` : ''
      }${office_id ? `&office_id=${office_id}` : ''}${assignee_id ? `&assignees=${assignee_id}` : ''
      }${status ? `&status=${status}` : ''}${approval_status ? `&approval_status=${approval_status}` : ''
      }`;
    const response = yield defaultApi(url, 'GET', payload);
    yield put({
      type: EXPORT_TASKS_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: EXPORT_TASKS_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    // Get tasks list
    takeLatest(GET_TASKS_LIST, handleGetTasksList),
    // Create task
    takeLatest(CREATE_TASK, handleCreateTaskList),
    //Get task details
    takeLatest(GET_TASK_DETAILS, handleGetTaskDetails),
    //Update task
    takeLatest(EDIT_TASK, handleEditTask),
    //Duplicate task
    takeLatest(DUPLICATE_TASK, handleDuplicateTask),
    //Delete task
    takeLatest(DELETE_TASK, handleDeleteTask),
    // Get task location
    takeLatest(GET_TASK_LOCATIONS, handleGetTaskLocations),
    // Add task location
    takeLatest(ADD_TASK_LOCATION, handleAddTaskLocation),

    takeLatest(UPDATE_TASK_STATUS, handleTaskApproval),
    // Get task type
    takeLatest(GET_TASK_TYPE, handleGetTaskType),
    takeLatest(GET_MASTER_TASK, handleGetMasterTask),
    //create master task
    takeLatest(CREATE_MASTER_TASK, handleCreateMasterTaskList),
    //create link between master task and new task
    takeLatest(CREATE_LINK_TASK, handleCreateLinkTaskList),

    takeLatest(CREATE_MAX_TASK_DURATION, handleCreateMaxTaskDuration),
    takeLatest(GET_MAX_TASK_DURATION, handleGetMaxTaskDuration),
    //get new tasks
    takeLatest(GET_NEW_TASK, handleGetNewTask),
    // Update task location
    takeLatest(UPDATE_TASK_LOCATION, handleUpdateTaskLocation),
    // Get location type list
    takeLatest(GET_LOCATION_TYPE_LIST, handleGetLocationTypeList),
    takeLatest(ARCHIVE_TASK_LOCATION, archiveTaskLocationSaga),
    takeLatest(UPDATE_MASTER_TASK, handleUpdateMasterTask),
    takeLatest(ARCHIVE_MASTER_TASK, handleArchiveMasterTask),
    takeLatest(UNARCHIVE_MASTER_TASK, handleUnarchiveMasterTask),
    takeLatest(EXPORT_TASKS, handleExportTasks),
  ]);
}
